import { SectionLayout } from '@tribeplatform/react-slate-kit/types'
import { SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

export const getColumnIconNames = (layout: SectionLayout): SvgIconName[] => {
  switch (layout) {
    case SectionLayout.Single:
      return ['columns-1-active']
    case SectionLayout.OneVOne:
      return ['columns-1-1-active-1', 'columns-1-1-active-2']
    case SectionLayout.OneVTwo:
      return ['columns-1-2-active-1', 'columns-1-2-active-2']
    case SectionLayout.TwoVOne:
      return ['columns-2-1-active-1', 'columns-2-1-active-2']
    case SectionLayout.Three:
      return ['columns-3-active-1', 'columns-3-active-2', 'columns-3-active-3']
    case SectionLayout.Four:
      return [
        'columns-4-active-1',
        'columns-4-active-2',
        'columns-4-active-3',
        'columns-4-active-4',
      ]
    default: {
      // Code should never reach the default case
      const _exhaustiveCheck: never = layout
      return []
    }
  }
}
